import { render } from "./AdsBrokerageCreating.vue?vue&type=template&id=fef90f8a&ts=true"
import script from "./AdsBrokerageCreating.vue?vue&type=script&lang=ts"
export * from "./AdsBrokerageCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__